import { React, useState } from 'react';

import Box from '@mui/material/Box';
import SolarPowerRoundedIcon from '@mui/icons-material/SolarPowerRounded';
import TableChartRoundedIcon from '@mui/icons-material/TableChartRounded';

import InserirGeracaoBulk from '../../components/atualizarGeracaoBulk';
import InserirGeracaoIndividual from '../../components/atualizarGeracaoIndividual';
import PageHeader from '../../components/pageHeader';
import { ModePanel, SegmentedControl } from '../../components/ui';
import '../css/generationEntry.css';

const InserirGeracao = () => {
    const [tipo, setTipo] = useState('individual');
    const isBulk = tipo === 'bulk';

    return (
        <Box className='mainBox ui-workflow-page'>
            <PageHeader>{isBulk ? 'Inserir Geração CSV' : 'Inserir Geração'}</PageHeader>

            <ModePanel icon={isBulk ? TableChartRoundedIcon : SolarPowerRoundedIcon} title={isBulk ? 'Envio por CSV' : 'Inserção individual'}>
                <SegmentedControl
                    ariaLabel='Alternar entre inserção individual e CSV'
                    value={tipo}
                    onChange={setTipo}
                    options={[
                        { value: 'individual', label: 'Individual', icon: SolarPowerRoundedIcon },
                        { value: 'bulk', label: 'CSV', icon: TableChartRoundedIcon }
                    ]}
                />
            </ModePanel>

            {isBulk ? <InserirGeracaoBulk /> : <InserirGeracaoIndividual /> }
        </Box>
    );
};

export default InserirGeracao;
